import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { AssetMap, GetAccountsResponse } from "@/util/util";

export interface ApexState {
  globalApexData: GetAccountsResponse;
  globalApexAssetMapData: AssetMap;
}

const initialState: ApexState = {
  globalApexData: { accounts: [], errors: [] },
  globalApexAssetMapData: { portfolio_map: {}, class_tree: [] },
};

const apexSlice = createSlice({
  name: "apex",
  initialState,
  reducers: {
    setGlobalApexData: (state, action: PayloadAction<any>) => {
      state.globalApexData = action.payload;
    },
    setGlobalApexAssetMapData: (state, action: PayloadAction<any>) => {
      state.globalApexAssetMapData = action.payload;
    },
    resetApex: (state) => {
      state.globalApexData = initialState.globalApexData;
      state.globalApexAssetMapData = initialState.globalApexAssetMapData;
    },
  },
});

export const { setGlobalApexData, setGlobalApexAssetMapData, resetApex } =
  apexSlice.actions;

export const globalApexData = (state: RootState) => state.apex.globalApexData;
export const globalApexAssetMapData = (state: RootState) =>
  state.apex.globalApexAssetMapData;

export default apexSlice.reducer;
